<template>
  <div class="flex flex-wrap mb-2" :style="(guideStep >= 19 && guideStep <= 34) || (guideStep == 271 || guideStep == 272) ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6">
      <div>
        <span v-if="!editPageType" class="text-red-500">*</span>
        <span class="text-grap-700 align-middle">{{lang['components']['Event']['GoalsAndBudget']['title']}}</span>
        <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'tooltip'"></i> -->
      </div>
      <div class="flex-1 space-y-4">
        <div class="space-y-2 pb-8" style="position:relative">
          <loading :active="!this.showGoalsAndBudget || !showGoalsAndBudgetMyside"
                  :can-cancel="true"
                  :on-cancel="onCancel"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'"
                  :loader=" dots">
          </loading>
          <div>
            <!-- <span class="text-red-500">*</span> -->
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['GoalsAndBudget']['item_1']}}</span>
            <i
              v-if="false"
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
              v-tooltip.top="`${lang['components']['Event']['GoalsAndBudget']['item_1_info']}`"
            ></i>
            <button
              v-if="false"
              id="goal"
              class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
              @click="teachVideo('goal')"
            >
              {{lang['components']['Event']['GoalsAndBudget']['video_teaching']}}
            </button>
          </div>
          <!-- 新手教學 -->
          <div
            class="grid grid-cols-1 lg:grid-cols-2"
            :class="{ 'ring-4 border-blue-400': guideStep === 20 }"
          >
            <!-- 新手教學 -->
            <div class="inline-flex items-center mt-3" :class="{ 'ring-4 border-blue-400': guideStep === 21, 'cursor-not-allowed': editPageType === true }">
              <input v-if="false" type="radio" class="form-radio h-5 w-5 text-blue-600" value="WEB_CONVERSIONS" :disabled="editPageType" v-model="viewDatalistData.objective_type" @click="objective_change($event)">
              <RadioButton class="o h-5 w-5" value="WEB_CONVERSIONS" :disabled="editPageType" v-model="viewDatalistData.objective_type" @click="objective_change($event)"/>
              <div class="flex flex-col w-11/12 break-words" >
                <div class="flex flex-wrap ml-2 text-gray-700 my-2">
                  <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['conversions_title']}}</span>
                  <Dropdown :disabled="editPageType" v-model="viewDatalistData.objective_option" optionLabel="name" optionValue="code" :options="viewDatalistData.objective_list" placeholder="--" class="w-2/3 ml-2 rounded-md" v-if="viewDatalistData.objective_type == 'WEB_CONVERSIONS'" />
                </div>
              </div>
            </div>
            <!-- <div v-if="!efficientAiStatus" class="inline-flex items-center mt-3"> -->
            <div v-if="false" class="inline-flex items-center mt-3">
              <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="VIDEO_VIEWS" :disabled="editPageType" v-model="viewDatalistData.objective_type" @click="objective_change($event)">
              <!-- <span class="ml-2 text-gray-700">觀看影片</span> -->
              <!-- 新手教學 -->
              <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 25 }">
                <div class="flex flex-wrap ml-2 text-gray-700 my-2">
                  <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['video_views_title']}}</span>
                  <Dropdown :disabled="editPageType" v-model="viewDatalistData.objective_option" optionLabel="name" optionValue="code" :options="viewDatalistData.objective_list" placeholder="--" class="w-2/3 ml-2 rounded-md" v-if="viewDatalistData.objective_type == 'VIDEO_VIEWS'" />
                </div>
              </div>
            </div>
            <!-- <div v-if="!efficientAiStatus" class="inline-flex items-center mt-3"> -->
            <div v-if="false" class="inline-flex items-center mt-3">
              <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="LINK_CLICKS" :disabled="editPageType" v-model="viewDatalistData.objective_type" @click="objective_change($event)">
              <!-- <span class="ml-2 text-gray-700">流量</span> -->
              <!-- 新手教學 -->
              <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 23 }">
                <div class="flex flex-wrap ml-2 text-gray-700 my-2">
                  <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['link_clicks_title']}}</span>
                  <Dropdown :disabled="editPageType" v-model="viewDatalistData.objective_option" optionLabel="name" optionValue="code" :options="viewDatalistData.objective_list" placeholder="--" class="w-2/3 ml-2 rounded-md" v-if="viewDatalistData.objective_type == 'LINK_CLICKS'" />
                </div>
              </div>
            </div>
            <!-- <div v-if="!efficientAiStatus" class="inline-flex items-center mt-3"> -->
            <div v-if="false" class="inline-flex items-center mt-3">
              <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="LEAD_GENERATION" :disabled="editPageType" v-model="viewDatalistData.objective_type" @click="objective_change($event)">
              <!-- <span class="ml-2 text-gray-700">開發潛在顧客</span> -->
              <!-- 新手教學 -->
              <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 26 }">
                <div class="flex flex-wrap ml-2 text-gray-700 my-2">
                  <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['lead_generation_title']}}</span>
                  <Dropdown :disabled="editPageType" v-model="viewDatalistData.objective_option" optionLabel="name" optionValue="code" :options="viewDatalistData.objective_list" placeholder="--" class="w-2/3 ml-2 rounded-md" v-if="viewDatalistData.objective_type == 'LEAD_GENERATION'" />
                </div>
              </div>
            </div>
            <!-- <div v-if="!efficientAiStatus" class="inline-flex items-center mt-3"> -->
            <div v-if="false" class="inline-flex items-center mt-3">
              <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="POST_ENGAGEMENT" :disabled="editPageType" v-model="viewDatalistData.objective_type" @click="objective_change($event)">
              <!-- <span class="ml-2 text-gray-700">互動</span> -->
              <!-- 新手教學 -->
              <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 24 }">
                <div class="flex flex-wrap ml-2 text-gray-700 my-2">
                  <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['post_engagement_title']}}</span>
                  <Dropdown :disabled="editPageType" v-model="viewDatalistData.objective_option" optionLabel="name" optionValue="code" :options="viewDatalistData.objective_list" placeholder="--" class="w-2/3 ml-2 rounded-md" v-if="viewDatalistData.objective_type == 'POST_ENGAGEMENT'" />
                </div>
              </div>
            </div>
            <!-- <div v-if="!efficientAiStatus" class="inline-flex items-center mt-3"> -->
            <div v-if="false" class="inline-flex items-center mt-3">
              <input type="radio" class="form-radio h-5 w-5 text-blue-600" value="MESSAGES" :disabled="editPageType" v-model="viewDatalistData.objective_type" @click="objective_change($event)">
              <!-- <span class="ml-2 text-gray-700">發送訊息</span> -->
              <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 27 }">
                <div class="flex flex-wrap ml-2 text-gray-700 my-2">
                  <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['messages_title']}}</span>
                  <Dropdown :disabled="editPageType" v-model="viewDatalistData.objective_option" optionLabel="name" optionValue="code" :options="viewDatalistData.objective_list" placeholder="--" class="w-2/3 ml-2 rounded-md" v-if="viewDatalistData.objective_type == 'MESSAGES'" />
                </div>
              </div>
            </div>
            <!-- <div v-if="!efficientAiStatus" class="inline-flex items-center mt-3"> -->
            <div v-if="false" class="inline-flex items-center mt-3">
              <input
                type="radio"
                class="form-radio h-5 w-5 text-blue-600"
                :class="{ '-mt-28': viewDatalistData.objective_type  == 'PRODUCT_CATALOG_SALES' }"
                :disabled="editPageType"
                 value="PRODUCT_CATALOG_SALES" v-model="viewDatalistData.objective_type" @click="objective_change($event)"
              />
              <div class="flex flex-col w-11/12 break-words" :class="{ 'ring-4 border-blue-400': guideStep === 271 }" >
                <div class="flex flex-wrap ml-2 text-gray-700 my-2">
                  <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['product_catalog_sales_title']}}</span>

                  <Dropdown :disabled="editPageType" v-model="viewDatalistData.product_catalog_id" optionLabel="name" optionValue="code" :options="viewDatalistData.product_catalog_list" placeholder="--" class="w-2/3 ml-2 rounded-md" v-if="viewDatalistData.objective_type == 'PRODUCT_CATALOG_SALES'" @change="product_catalog_change($event)" />
                  <i
                    class="mt-1 ml-2 pi pi-exclamation-circle align-middle text-gray-300"
                     v-if="viewDatalistData.objective_type == 'PRODUCT_CATALOG_SALES'"
                    v-tooltip="`${lang['components']['Event']['GoalsAndBudget']['product_catalog_sales_title_info']}`"
                  ></i>
                </div>
                <div class="flex flex-wrap ml-2 text-gray-700 my-2" v-if="viewDatalistData.objective_type == 'PRODUCT_CATALOG_SALES'">
                  <span class="my-2 text-sm">{{lang['components']['Event']['GoalsAndBudget']['product_catalog_id_title']}}</span>
                  <Dropdown :disabled="editPageType || (viewDatalistData.product_catalog_id == '' || typeof viewDatalistData.product_catalog_id == 'undefined')" v-model="viewDatalistData.product_set_id" optionLabel="name" optionValue="code" :options="viewDatalistData.product_set_list" placeholder="--" class="w-2/3 ml-2 rounded-md" v-if="viewDatalistData.objective_type == 'PRODUCT_CATALOG_SALES'" @change="product_set_change($event)" />
                </div>
                <div class="flex flex-wrap ml-2 text-gray-700 my-2" v-if="viewDatalistData.objective_type == 'PRODUCT_CATALOG_SALES'">
                  <span class="my-2 text-sm mr-7">{{lang['components']['Event']['GoalsAndBudget']['product_set_id_title']}}</span>
                  <Dropdown :disabled="editPageType || (viewDatalistData.product_set_id == '' || typeof viewDatalistData.product_set_id == 'undefined')" v-model="viewDatalistData.objective_option" optionLabel="name" optionValue="code" :options="viewDatalistData.objective_list" placeholder="--" class="w-2/3 ml-2 rounded-md" v-if="viewDatalistData.objective_type == 'PRODUCT_CATALOG_SALES'" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 272 }">
          <div class="flex">
            <div>
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['GoalsAndBudget']['application_events_title']}}</span>
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="`${lang['components']['Event']['GoalsAndBudget']['application_events_info']}`"
              ></i>
            </div>
            <div class="text-grap-700 text-sm ml-4 mt-1">
              <InputSwitch v-model="viewDatalistData.useAppEvent" class="-my-1" :disabled="editPageType" />
              <span class="mx-1">{{lang['components']['Event']['GoalsAndBudget']['useAppEvent_title']}}</span>
            </div>
          </div>

          <div class="flex flex-wrap">
            <Dropdown v-model="viewDatalistData.appItemsSelected" :options="viewDatalistData.appItemsList" optionLabel="name" optionValue="code" placeholder="-" class="w-1/3 rounded-md" :disabled="(viewDatalistData.useAppEvent === false && editPageType === false) || editPageType === true" />
          </div>
        </div> -->
        <!-- 新手教學 -->
        <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 28 }">
          <div>
            <!-- <span v-if="efficientAiStatus" class="text-red-500">*</span> -->
            <!-- <span class="text-red-500">*</span> -->
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['GoalsAndBudget']['effect_title']}}</span>
            <i
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
              v-tooltip.top="`${lang['components']['Event']['GoalsAndBudget']['effect_title_info']}`"
            ></i>
            <button
              v-if="false"
              id="effect"
              class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
              @click="teachVideo('effect')"
            >
              {{lang['components']['Event']['GoalsAndBudget']['video_teaching']}}
            </button>
          </div>
          <div
            class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-48"
          >
            <input
              :disabled="efficientAi && editPageType"
              type="text"
              class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
              v-model="viewDatalistData.effect"
              @keyup="num(viewDatalistData.effect, currencyListData.currency_offset)"
            />
            <span class="text-xs text-gray-400">{{currencyListData.currency}}</span>
          </div>
        </div>
        <!-- <div class="space-y-2 pb-8">
          <div>
            <span class="text-red-500">*</span>
            <span class="text-grap-700 align-middle text-sm">風險係數</span>
            <i
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
              v-tooltip.top="'風險係數'"
            ></i>
          </div>
          <div class="flex flex-wrap">
            <div
              class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-24"
            >
              <input
                type="text"
                class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                v-model="viewDatalistData.risk_index"
              />
              <span class="text-xs text-gray-400">%</span>
            </div>
            <div
              class="rounded ml-1 mt-1 px-2 py-1 text-xs bg-gray-200 text-gray-400"
            >
              ± 風險自動修正
            </div>
          </div>
          <input type="range" class="w-1/3" v-model="range" />
        </div> -->
        <!-- 新手教學 -->
        <!-- <div v-if="!efficientAiStatus" class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 29 || guideStep === 30 || guideStep === 31 || guideStep === 32 || guideStep === 33 }"> -->
        <div class="space-y-2 pb-8">
          <div>
            <!-- <span class="text-red-500">*</span> -->
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['GoalsAndBudget']['risk_level_title']}}</span>
            <i
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
              v-tooltip.top="`${lang['components']['Event']['GoalsAndBudget']['risk_level_title_info']}`"
            ></i>
            <button
              v-if="false"
              id="risk_level"
              class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
              @click="teachVideo('risk')"
            >
              {{lang['components']['Event']['GoalsAndBudget']['video_teaching']}}
            </button>
          </div>

          <SelectButton
            :disabled="editPageType && this.risk_level_code == 'auto' && this.dbRiskLevelCode == 'auto'"
            v-model="viewDatalistData.risk_level"
            :options="viewDatalistData.risk_level_list"
            optionLabel="name"
          >
            <template #option="slotProps">
              <div class="w-20" :class="{ 'h-20': useLang == 'en-US', 'h-10': (useLang == 'zh-CN' || useLang == 'zh-TW') }">
                <!-- <p :class="{ 'hor-ver-center': budgetUse != slotProps.option }">
                  {{ slotProps.option.name }}
                </p>
                <p v-if="budgetUse == slotProps.option" class="text-xs">
                  {{ slotProps.option.sub }}
                </p> -->
                <p :class="{ 'hor-ver-center': viewDatalistData.risk_level.code != slotProps.option.code }">
                  {{ slotProps.option.name }}
                </p>
                <p v-if="viewDatalistData.risk_level.code == slotProps.option.code" class="text-xs">
                  {{ viewDatalistData.risk_level.sub }}
                </p>
              </div>
            </template>
          </SelectButton>
        </div>
        <!-- 新手教學 -->
        <!-- <div v-if="!efficientAiStatus" class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 34 }"> -->
        <div class="space-y-2 pb-8">
          <!-- <div>
            <span class="text-red-500">*</span>
            <span class="text-grap-700 align-middle text-sm">預算比率</span>
            <i
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
              v-tooltip.top="'預算比率'"
            ></i>
          </div> -->
          <div class="flex">
            <div>
              <!-- <span class="text-red-500">*</span> -->
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['GoalsAndBudget']['form_addition_title']}}</span>
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="`${lang['components']['Event']['GoalsAndBudget']['form_addition_title_info']}`"
              ></i>
              <button
                v-if="false"
                id="addition"
                class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
                @click="teachVideo('addition')"
              >
                {{lang['components']['Event']['GoalsAndBudget']['video_teaching']}}
              </button>
            </div>
            <div class="text-grap-700 text-sm ml-4 mt-1">
              <InputSwitch v-model="viewDatalistData.budget_switch" class="-my-1" />
              <span class="mx-1">{{lang['components']['Event']['GoalsAndBudget']['use_addition_title']}}</span>
            </div>
          </div>

          <div class="flex flex-wrap">
            <span class="text-sm text-gray-500 mr-2 mt-1">{{lang['components']['Event']['GoalsAndBudget']['add_text']}}</span>
            <div
              class="bg-white rounded-md flex items-center p-1 shadow-sm border border-gray-200 w-24"
            >
              <!-- <input
                type="text"
                class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                v-model="viewDatalistData.budget_increase"
                oninput = "value=value.replace(/[^\d]/g,'')"
                @blur="budgetAddition(viewDatalistData.budget_increase)"
                :disabled="!viewDatalistData.budget_switch"
              /> -->
              <input
                type="text"
                class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                v-model="viewDatalistData.budget_increase"
                oninput = "value=value.replace(/[^\d]/g,'')"
                :disabled="!viewDatalistData.budget_switch"
              />
              <span class="text-xs text-gray-400">%</span>
            </div>
            <span v-if="false" class="bg-white text-blue-500 text-sm ml-2 mt-1">最低 {{minAddition}} %</span>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar"></div>
    <!-- 新手教學 -->
    <div v-if="(guideStep >= 19 && guideStep <= 34) || guideStep == 271" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0);"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
import { createApp, ref, watch } from 'vue'
import Dropdown from "primevue/dropdown";
import RadioButton from 'primevue/radiobutton';
import CascadeSelect from "primevue/cascadeselect";
import SelectButton from "primevue/selectbutton";
import InputSwitch from 'primevue/inputswitch';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import Vue3DraggableResizable from 'vue3-draggable-resizable'
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "GoalsAndBudget",
  components: {
    Dropdown,
    RadioButton,
    CascadeSelect,
    SelectButton,
    InputSwitch,
    Loading
  },
  props: {
    // <!-- 新手教學 -->
    guideStep: {
      type: Number,
      default: 1
    },
    // <!-- 新手教學 -->
    showGoalsAndBudget: {
      type: Boolean
    },
    editPage: {
      type: Boolean
    },
    getDate: {
      type: Number
    },
    budgetKWTotal: {
      type: Number
    },
    useEndDate: {
      type: Number
    },
    formMinAddition: {
      type: Number
    },
    viewDatalist: {
      type: Object
    },
    dbRiskLevelCode: {
      type: String
    },
    currencyList: {
      type: Object
    },
    lang: {
      type: Object
    },
    useLang: {
      type: String
    },
    youtubeClose: {
      type: Boolean
    },
    efficientAi: {
      type: Boolean
    }
  },
  data() {
    return {
      showGoalsAndBudgetMyside: true,
      type: null,
      range: 20,
      transformCount: {id: "333", name: "消費金額"},
      transformDomain: null,
      isSetting: false,
      minAddition: 0,
      tmpObjective: '',
      productCatalogId: '',
      oldS: [
        {
          name: "購買-未來實驗室的像素",
          code: "01",
          sub: [
            {
              id: "333",
              name: "消費金額"
            },
            {
              id: "02",
              name: "轉換次數"
            }
          ]
        },
        {
          name: "開始結帳-未來實驗室的像素",
          code: "01",
          // sub: [
          //   {
          //     id: "01",
          //     name: "消費金額"
          //   },
          //   {
          //     id: "02",
          //     name: "轉換次數"
          //   }
          // ]
        },
        {
          name: "加入購物車-未來實驗室的像素",
          code: "01",
          sub: [
            {
              id: "01",
              name: "消費金額"
            },
            {
              id: "02",
              name: "轉換次數"
            }
          ]
        },
        {
          name: "完成註冊-未來實驗室的像素",
          code: "01",
          sub: [
            {
              id: "01",
              name: "消費金額"
            },
            {
              id: "02",
              name: "轉換次數"
            }
          ]
        },
        {
          name: "瀏覽內容-未來實驗室的像素",
          code: "01",
          sub: [
            {
              id: "01",
              name: "消費金額"
            },
            {
              id: "02",
              name: "轉換次數"
            }
          ]
        },
        {
          name: "潛在客戶-未來實驗室的像素",
          code: "01",
          sub: [
            {
              id: "01",
              name: "消費金額"
            },
            {
              id: "02",
              name: "轉換次數"
            }
          ]
        }
      ],
      domain: "",
      domainList: [],
      budgetUse: {},
      budgetUseList: [],
      risk_level_code: 'medium',
      x: 0,
      y: 0,
      h: 200,
      w: 320,
      active: false,
      src: "https://www.youtube.com/watch?v=6vD-2v5RWyk",
      vars: {
        rel: 0,
        start: 0,
        end: 0,
      },
      view_youtube: false,
      efficientAiStatus: true,
    };
  },
  watch: {
    'youtubeClose':function(v){
      // console.log('marketingmethod youtubeClose');
      // console.log(v);

      let _tmpYoutubeType = v.split('_');

      // console.log('_tmpYoutubeType');
      // console.log(_tmpYoutubeType);

      // console.log(typeof this.view_youtube);
      // console.log(this.view_youtube);

      if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
        if(_tmpYoutubeType[0] == 'false' || (_tmpYoutubeType[1] != 'goal' && _tmpYoutubeType[1] != 'effect' && _tmpYoutubeType[1] != 'risk' && _tmpYoutubeType[1] != 'addition')){
          // console.log('關閉#1');
          this.view_youtube = false
        } else {
          this.view_youtube = false
          setTimeout(() => {
            // console.log("Delayed for 0.3 second.");
            this.teachVideo(_tmpYoutubeType[1]);
          }, "300")
        }
      }

      // console.log('完畢');
      // console.log(typeof this.view_youtube);
      // console.log(this.view_youtube);
    },
    // 'efficientAi': function(v){
    //   console.log('goais efficientAi');
    //   console.log(v);
    //   this.efficientAiStatus = v

    //   if(v == true){
    //     axios
    //       .post('https://www.autoturn.net/api/campaign_form_action_event.php', Qs.stringify({
    //         s_code: this.$route.params.id,
    //         adaccount_id: this.$route.params.adaccount_id,
    //         campaign_id: this.$route.params.campaign_id,
    //         objective_type: 'CONVERSIONS',
    //         efficient_ai: v
    //       }))
    //       .then((response) => {
    //         if(response.data.status == 'success'){
    //           this.viewDatalistData.objective_list = response.data.return_data.objective_list
    //         }

    //         // this.showGoalsAndBudgetMyside = true;
    //       });
    //   }
    // },
    lang(value){
      this.budgetUse = { name: this.lang['components']['Event']['GoalsAndBudget']['budget']['name_medium'], sub: this.lang['components']['Event']['GoalsAndBudget']['budget']['sub_medium'], code: "medium" };
      this.budgetUseList = [
        { name: this.lang['components']['Event']['GoalsAndBudget']['budget']['name_high'], sub: this.lang['components']['Event']['GoalsAndBudget']['budget']['sub_high'], code: "high" },
        { name: this.lang['components']['Event']['GoalsAndBudget']['budget']['name_medium'], sub: this.lang['components']['Event']['GoalsAndBudget']['budget']['sub_medium'], code: "medium" },
        { name: this.lang['components']['Event']['GoalsAndBudget']['budget']['name_low'], sub: this.lang['components']['Event']['GoalsAndBudget']['budget']['sub_low'], code: "low" },
        { name: this.lang['components']['Event']['GoalsAndBudget']['budget']['name_auto'], sub: this.lang['components']['Event']['GoalsAndBudget']['budget']['sub_auto'], code: "auto" }
      ];
    },
    transformCount (value){
      // console.log(this.transformCount);
      // console.log(value);
    },
    transformDomain (value){
      // console.log('transformDomain');
      // console.log(this.transformDomain);
      // console.log(value);
    },
    'viewDatalistData.objective_type'(value){
      // console.log('viewDatalistData.objective_type');
      // console.log(value);
      if(value != '' && value != null && typeof value != 'undefined'){
        this.tmpObjective = value;
      }
      this.$emit('childObjective', value);
    },
    'viewDatalistData.objective_option'(value){
      // console.log('objective_option viewDatalistData.objective_list');
      // console.log(this.viewDatalistData.objective_list);

      // console.log('viewDatalistData.objective_option:'+value);

      this.$emit('childObjectiveOption', value);
    },
    'viewDatalistData.objective_list'(value){
      // console.log('viewDatalistData.objective_list:'+value);

      // console.log('objective_lists viewDatalistData.objective_option');
      // console.log(this.viewDatalistData.objective_option);
    },
    'viewDatalistData.domain_list'(value){
      // console.log('viewDatalistData.domain_list:'+value);
    },
    // 'viewDatalistData.use_addition'(value){
    //   if(value == false){
    //     this.viewDatalistData.form_addition = 0;
    //   }
    // },
    // 'viewDatalistData.useAppEvent'(value){
    //   console.log(this.viewDatalistData.appItemsList);
    //   if(value === false){
    //     this.viewDatalistData.appItemsSelected = null;
    //   } else {
    //     if(this.viewDatalistData.appItemsSelected == '' || this.viewDatalistData.appItemsSelected == null || typeof this.viewDatalistData.appItemsSelected === "undefined"){
    //       this.viewDatalistData.appItemsSelected = this.viewDatalistData.appItemsList[0].code;
    //     }
    //   }
    // },
    'viewDatalistData.budget_switch'(value){
      // console.log('viewDatalistData.budget_switch');
      // console.log(value);

      if(value == false){
        this.viewDatalistData.budget_increase = 0;
      }
    },
    'formMinAddition'(value){
      // console.log('formMinAddition:'+this.formMinAddition);
      // console.log('this.viewDatalistData.form_addition:'+this.viewDatalistData.form_addition);
      this.minAddition = this.formMinAddition;

      if(this.viewDatalistData.form_addition < this.formMinAddition){
        this.viewDatalistData.form_addition = this.formMinAddition;
      }
    },
    'viewDatalistData.risk_level'(value){
      // console.log('viewDatalistData.risk_level:'+value.code);
      this.risk_level_code = value.code
    },
  },
  methods: {
    onReady() {
      // console.log('youtube');
      this.$refs.youtube.playVideo()
      // this.$refs.youtube.pauseVideo()
    },
    onStateChange(e){
      // console.log(e);

      if(e.data == 0){
        this.view_youtube = false
      }
    },
    teachVideo(v){
      this.$emit('checkClose')

      // console.log('b teachVideo this.view_youtube');
      // console.log(this.view_youtube);

      // this.view_youtube = false
      // let elem = document.getElementById('marketingDate');
      // let positio = this.getPosition(elem);
      // console.log('x:'+positio.x);
      // console.log('y:'+positio.y);

      // console.log('a teachVideo this.view_youtube');
      // console.log(this.view_youtube);

      // this.x = positio.x + parseInt(80);
      // this.y = positio.y

      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;

      // console.log('windowWidth');
      // console.log(windowWidth);
      // console.log('windowHeight');
      // console.log(windowHeight);

      this.x = windowWidth - parseInt(390);
      this.y = windowHeight - parseInt(350);

      this.view_youtube = true;
      this.$emit('childYoutube', 'true_'+v)

      // console.log('a this.view_youtube');
      // console.log(this.view_youtube);

      // console.log(v);

      switch(v){
        case 'goal':
          this.vars.start = 0
          this.vars.end = 42
          break;
        case 'effect':
          this.vars.start = 42
          this.vars.end = 91
          break;
        case 'risk':
          this.vars.start = 91
          this.vars.end = 179
          break;
        case 'addition':
          this.vars.start = 179
          this.vars.end = 227
          break;
      }

      this.playAgain = false
    },
    getPosition(element) {
      let x = 0;
      let y = 0;

      while ( element ) {
        x += element.offsetLeft - element.scrollLeft + element.clientLeft;
        y += element.offsetTop - element.scrollLeft + element.clientTop;
        element = element.offsetParent;
      }

      return { x: x, y: y };
    },
    print(val) {
      // console.log(val)
    },
    doDragging(){
      // console.log('doDragging');
    },
    setDomain() {
      if (this.domain) {
        var checkDomain = false;
        // console.log(this.viewDatalistData.domain_list);
        // console.log(this.domain);
        for (let i = 0; i < this.viewDatalistData.domain_list.length; i++) {
          if (this.viewDatalistData.domain_list[i].name === this.domain) {
            checkDomain = true
          }
        }

        if(checkDomain == false){
          let newOpt = { name: this.domain };
          this.viewDatalistData.domain_list.push(newOpt);
          this.transformDomain = newOpt;
          this.viewDatalistData.conversion_domain = newOpt;
        }
      }
    },
    objective_change (e) {
      // console.log('objective_change');
      // console.log(e.target.value);
    //   axios
    //     .post('https://www.autoturn.net/api/campaign_form_action_event.php', Qs.stringify({
    //       s_code: this.$route.params.id,
    //       adaccount_id: this.$route.params.adaccount_id,
    //       campaign_id: this.$route.params.campaign_id,
    //       objective_type: e.target.value
    //     }))
    //     .then((response) => {
    //       if(response.data.status == 'success'){
    //         this.viewDatalistData.objective_list = response.data.return_data.objective_list
    //       }

    //       this.showGoalsAndBudgetMyside = true;
    //     });
    // },
    // product_catalog_change(e){
    //   console.log('product_catalog_change');
    //   console.log(e.value);
    //   console.log(this.viewDatalistData.product_catalog_id);
    //   let product_catalog_id = this.viewDatalistData.product_catalog_id;

    //   if(product_catalog_id != '' && product_catalog_id != null && typeof product_catalog_id != 'undefined'){
    //     this.showGoalsAndBudgetMyside = false;
    //     this.productCatalogId = product_catalog_id

    //     axios
    //       .post('https://www.autoturn.net/api/campaign_form_catalog_product_sets.php', Qs.stringify({
    //         s_code: this.$route.params.id,
    //         catalog_id: product_catalog_id
    //       }))
    //       .then((response) => {
    //         if(response.data.status == 'success'){
    //           this.viewDatalistData.product_set_list = response.data.return_data.objective_list
    //         }

    //         this.showGoalsAndBudgetMyside = true;
    //       });
    //   } else {
    //     Swal.fire(
    //                 this.lang['components']['Event']['GoalsAndBudget']['methods']['product_catalog_change']['swal_title'],
    //                 this.lang['components']['Event']['GoalsAndBudget']['methods']['product_catalog_change']['swal_text'],
    //                 "warning"
    //               )
    //   }
    // },
    // product_set_change(e){
    //   console.log('product_catalog_change');
    //   console.log(e);
    //   // console.log(this.viewDatalistData.product_set_id);
    //   // let product_set_id = this.viewDatalistData.product_set_id;
    //   let product_catalog_id = this.viewDatalistData.product_catalog_id;
    //   if(product_catalog_id != '' && product_catalog_id != null && typeof product_catalog_id != 'undefined'){
    //     this.showGoalsAndBudgetMyside = false;

    //     axios
    //       .post('https://www.autoturn.net/api/campaign_form_action_event.php', Qs.stringify({
    //         s_code: this.$route.params.id,
    //         adaccount_id: this.$route.params.adaccount_id,
    //         campaign_id: this.$route.params.campaign_id,
    //         objective_type: this.tmpObjective,
    //         catalog_id: product_catalog_id
    //       }))
    //       .then((response) => {
    //         if(response.data.status == 'success'){
    //           this.viewDatalistData.objective_list = response.data.return_data.objective_list

    //           console.log(this.viewDatalistData.objective_list);
    //         }

    //         this.showGoalsAndBudgetMyside = true;
    //       });
    //   } else {
    //     Swal.fire(
    //                 this.lang['components']['Event']['GoalsAndBudget']['methods']['product_set_change']['swal_title'],
    //                 this.lang['components']['Event']['GoalsAndBudget']['methods']['product_set_change']['swal_text'],
    //                 "warning"
    //               )
    //   }
    },
    budgetAddition(value){
      // console.log('value budgetAddition:'+value);

      // console.log('getDate budgetAddition:'+this.getDate);
      // console.log('budgetKWTotal budgetAddition:'+this.budgetKWTotal);
      // console.log('useEndDate budgetAddition:'+this.useEndDate);

      if(this.useEndDate == false){
        //有結束日期
        // console.log('有結束日期');
        //先算精準興趣總預算

        if(!isNaN(this.getDate) && this.getDate > 0){
          // console.log('有日期間距');
          var _tmp_days = this.getDate;
          var _tmp_total = this.budgetKWTotal;
          // var _tmp_budget_addition = (budget_addition == '' || budget_addition == 0)?0:budget_addition/100
          var _tmp_interval_week = 0;
          var interval_week = 0;
          var n = 0;
          var html = 0;
          var video_min_price = this.viewDatalistData.currency_video_min_price;
          var _tmp_budget_addition = video_min_price;

          let _test_total = 0;

          if(_tmp_days > 0){
              if(_tmp_days > 3){
                  n = Math.round(_tmp_days/7);
              }
          }

          //console.log(_tmp_total+'*7');
          var first_week = _tmp_total*7;

          for(var i = 1; i < n; i++){
              var days_pow = i + 1;
              // console.log('days_pow:'+days_pow);
              // console.log(_tmp_total+' * Math.pow((1 + '+_tmp_budget_addition+'), '+days_pow+') * 7');

              //console.log('('+_tmp_total +'+ ('+days_pow+' - 1) * '+_tmp_budget_addition+') * 7');
              _tmp_interval_week = (parseInt(_tmp_total) + (parseInt(days_pow) - 1) * parseInt(_tmp_budget_addition)) * 7;

              // console.log(interval_week +'='+ interval_week +'+'+ _tmp_interval_week);
              interval_week = interval_week + _tmp_interval_week;
          }

          // console.log(_tmp_total + ' * Math.pow((1 + '+_tmp_budget_addition+'), '+n+') * ('+_tmp_days+' - 7 * '+n+')');

          //console.log('('+_tmp_total +'+'+ n +'*'+ _tmp_budget_addition+') * ('+_tmp_days +' - 7 * '+ n+')');
          var finish_week = (parseInt(_tmp_total) + parseInt(n) * parseInt(_tmp_budget_addition)) * (parseInt(_tmp_days) - 7 * parseInt(n));

          if(_tmp_days > 0 && _tmp_total > 0){
              // console.log('Math.round('+first_week +'+'+ interval_week +'+'+ finish_week+')');
              html = Math.round(parseInt(first_week) + parseInt(interval_week) + parseInt(finish_week));
          }

          _test_total = html;

          //計算最低預算比率
          let _ratio = ((Math.ceil(((parseInt(_test_total) / (parseInt(_tmp_total) * parseInt(_tmp_days))))*100)/100 - 1)*100).toFixed(0);

          this.minAddition = _ratio;

          if(parseInt(value) < parseInt(_ratio)){
            // console.log('有結束日期之下，不允許小於:'+_ratio);
            this.viewDatalistData.form_addition = _ratio;
          } else {
            // console.log(value +" > "+ _ratio);
          }
        } else {
          // console.log('沒結束日期也沒日期間距');
          var _tmp_keyword_split_budget = this.budgetKWTotal;
          var video_min_price = this.viewDatalistData.currency_video_min_price;
          var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
          if(_tmp_keyword_split_budget == 0){
              single_ratio = 0;
          }

          this.minAddition = single_ratio;

          if(parseInt(value) < parseInt(single_ratio)){
            // console.log('沒結束日期之下，不允許小於:'+single_ratio);
            this.viewDatalistData.form_addition = single_ratio;
          } else {
            // console.log(value +" > "+ single_ratio);
          }
        }

      } else {
        //沒結束日期
        // console.log('沒結束日期');
        var _tmp_keyword_split_budget = this.budgetKWTotal;
        var video_min_price = this.viewDatalistData.currency_video_min_price;
        var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        if(_tmp_keyword_split_budget == 0){
            single_ratio = 0;
        }

        this.minAddition = single_ratio;

        if(value < single_ratio){
          // console.log('沒結束日期之下，不允許小於:'+single_ratio);
          this.viewDatalistData.form_addition = single_ratio;
        } else {
          // console.log(value +" > "+ single_ratio);
        }
      }
    },
    num(value, offset){
      // console.log('num');
      // console.log(value +' | '+ offset)
      if(offset == 100){
        value = value.replace(/[^\d.]/g,"");
        value = value.replace(/^\./g,"");
        value = value.replace(/\.{2,}/g,".");
        value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        value = value.replace(/^(\-)*(\d+)\.(\d{2}).*$/,'$1$2.$3');
      } else {
        value = value.replace(/[^\d]/g,'')
      }


      this.viewDatalistData.effect = value;
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist
      },
      set: function (value) {
        this.$emit('update:viewDatalistData', value)
      },
    },
    currencyListData: {
      get: function () {
        return this.currencyList
      },
      set: function (value) {
        this.$emit('update:currencyListData', value)
      },
    },
  }
};
</script>

<style lang="scss" scope>
.p-tooltip {
  max-width: 23rem !important;
}
</style>

<style type="text/css">
  .p-selectbutton .p-button.p-highlight:hover, .p-selectbutton .p-button.p-highlight {
    background: #111827;
    border-color: #111827;
    color: #fff;
  }

  .p-radiobutton .p-radiobutton-box.p-highlight {
    border-color: #111827;
    background: #111827;
  }

  .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
    border-color: #111827;
    background: #111827;
    color: #fff;
  }
</style>